import { render, staticRenderFns } from "./EmailSidebar.vue?vue&type=template&id=4472c645&scoped=true"
import script from "./EmailSidebar.vue?vue&type=script&lang=js"
export * from "./EmailSidebar.vue?vue&type=script&lang=js"
import style0 from "./EmailSidebar.vue?vue&type=style&index=0&id=4472c645&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4472c645",
  null
  
)

export default component.exports